import React from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import { components } from "react-select";
import { BestLabel, BestSelect, ButtonLink, Input, RequiredIndicator, RequiredInputWithLabel } from "best-common-react";
// import NewContactModal from "../contacts/NewContactModal";
// import SelectContactModal from "../contacts/SelectContactModal";
import PhoneInputWithCountrySelect, { isValidPhoneNumber } from "react-phone-number-input";
import { CommonConstants } from "../../../constants/CommonConstants";

const CommentInput = styled.textarea.attrs({ maxLength: "150", id: "comment-text-area" })`
  height: 5em;
`;

const SectionOption = ({ data, ...rest }) => (
  <components.Option {...rest}>
    {data && data.value && (
      <div className="d-flex justify-content-between">
        <div>
          {data.value.sectionNumber} @ ${data.value.price}
        </div>
        <div>{data.value.left} left</div>
      </div>
    )}
  </components.Option>
);

const SectionValue = ({ data, ...rest }) => (
  <components.ValueContainer {...rest}>
    {data && data.value && (
      <div>
        <span className="mr-3">
          {data.value.sectionNumber} @ ${data.value.price}
        </span>
        <span>{data.value.left} left</span>
      </div>
    )}
  </components.ValueContainer>
);

function ParkingPassFilters(props) {
  const { parkingPassStore, commonStore, authStore, contactStore } = props.rootStore;

  return (
    <div>
      {/*{!!contactStore.showNewContactModal && (*/}
      {/*  <NewContactModal parkingPassStore={parkingPassStore} contactStore={contactStore} />*/}
      {/*)}*/}
      {/*{!!contactStore.showSelectContactModal && <SelectContactModal contactStore={contactStore} />}*/}
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div
              hidden={
                !authStore.isAdmin &&
                !authStore.isUmpireAttendant &&
                !(authStore.isBoxOfficeAdmin && commonStore.currentOrgId === CommonConstants.KEYS.UMP_ID)
              }
              className="col col-lg-4 col-12 form-group"
            >
              <BestLabel htmlFor="on-behalf-of">Request On Behalf Of</BestLabel>
              <BestSelect
                id="on-behalf-of"
                options={parkingPassStore.userDropdown}
                value={parkingPassStore.selectedUser}
                onChange={item => parkingPassStore.setUser(item.value)}
                isSearchable={true}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12 form-group">
              <div className="d-flex justify-content-between align-items-end">
                <BestLabel htmlFor="firstName">
                  First Name <RequiredIndicator />
                </BestLabel>
                <ButtonLink
                  style={{ fontSize: "0.875rem", padding: "0px" }}
                  onClick={() => contactStore.setShowSelectContactModal(true)}
                >
                  Select Contact
                </ButtonLink>
              </div>
              <input
                type="text"
                className="form-control"
                name="firstName"
                id="firstName"
                value={parkingPassStore.firstName}
                onChange={firstName => parkingPassStore.setFirstName(firstName.target.value)}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12 form-group">
              <RequiredInputWithLabel name="lastName" label="Last Name" htmlFor="lastName">
                <input
                  type="text"
                  className="form-control"
                  name="lastName"
                  id="lastName"
                  value={parkingPassStore.lastName}
                  onChange={lastName => parkingPassStore.setLastName(lastName.target.value)}
                />
              </RequiredInputWithLabel>
            </div>
          </div>
          <div className="secondRow row">
            <div className="col-lg-4 col-12 form-group">
              <RequiredInputWithLabel name="relation" label="Relation" htmlFor="friends-family">
                <BestSelect
                  id="friends-family"
                  options={commonStore.friendsAndFamilyDropdown}
                  value={parkingPassStore.selectedRelation}
                  onChange={item => parkingPassStore.setRelation(item)}
                />
              </RequiredInputWithLabel>
            </div>
            <div className="col-lg-4 col-12 form-group">
              <RequiredInputWithLabel name="availableSections" label="Available Sections" htmlFor="sections">
                <BestSelect
                  id="sections"
                  disabled={true}
                  options={parkingPassStore.sectionInventoryOptions}
                  value={
                    parkingPassStore.sectionInventoryOptions.length > 0
                      ? parkingPassStore.sectionInventoryOptions[0]
                      : {}
                  }
                  onChange={item => parkingPassStore.setSelectedSection(item)}
                  components={{ Option: SectionOption, SingleValue: SectionValue }}
                  placeholder=""
                />
              </RequiredInputWithLabel>
            </div>
            <div className="col-lg-4 col-12 form-group">
              <RequiredInputWithLabel name="quantity" label="Quantity" htmlFor="allotment">
                <BestSelect
                  id="allotment"
                  disabled={true}
                  options={[]}
                  value="N/A"
                  onChange={item => {}}
                  placeholder="N/A"
                />
              </RequiredInputWithLabel>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-12 form-group">
              <RequiredInputWithLabel name="pickupLocation" label="Pickup Location" htmlFor="pickup-location">
                <BestSelect
                  id="pickup-location"
                  disabled={true}
                  options={parkingPassStore.pickupLocationDropdown}
                  value={parkingPassStore.pickupLocationDropdown ? parkingPassStore.pickupLocationDropdown[0] : {}}
                  onChange={item => parkingPassStore.setPickupLocation(item)}
                />
              </RequiredInputWithLabel>
            </div>
            {parkingPassStore.pickupLocation && parkingPassStore.pickupLocation.value.digitalDelivery ? (
              <React.Fragment>
                {parkingPassStore.pickupLocation.value.requireEmail ? (
                  <div className="col-lg-4 col-12 form-group">
                    <RequiredInputWithLabel name="deliveryEmail" label="Email" htmlFor="delivery-email">
                      <Input
                        type="email"
                        className="form-control"
                        id="delivery-email"
                        value={parkingPassStore.deliveryEmail}
                        onChange={deliveryEmail => parkingPassStore.setDeliveryEmail(deliveryEmail.target.value)}
                      />
                    </RequiredInputWithLabel>
                  </div>
                ) : null}
                {parkingPassStore.pickupLocation.value.requireMobilePhone ? (
                  <div className="col-lg-4 col-12 form-group">
                    <RequiredInputWithLabel name="deliveryMobilePhone" label="Mobile Phone" htmlFor="intl-tel-input-2">
                      <PhoneInputWithCountrySelect
                        placeholder="US/Canada Only"
                        defaultCountry={parkingPassStore.countryCode || "US"}
                        countries={["US", "CA"]}
                        international={false}
                        addInternationalOption={false}
                        countryCallingCodeEditable={false}
                        className={
                          "d-flex form-control " +
                          (parkingPassStore.deliveryMobilePhone &&
                          isValidPhoneNumber(parkingPassStore.deliveryMobilePhone)
                            ? ""
                            : "is-invalid")
                        }
                        onChange={value => {
                          parkingPassStore.setDeliveryMobilePhone(value);
                        }}
                        onCountryChange={value => {
                          parkingPassStore.setCountryCode(value);
                        }}
                        value={parkingPassStore.deliveryMobilePhone}
                      />
                    </RequiredInputWithLabel>
                  </div>
                ) : null}
              </React.Fragment>
            ) : null}
            {parkingPassStore.pickupLocation && parkingPassStore.pickupLocation.value.allowEitherContactMethod ? (
              <React.Fragment>
                <div className="col-12 pb-2">Please enter a valid e-mail address or USA/Canada phone number.</div>
                <div className="col-lg-4 col-12 form-group">
                  <BestLabel htmlFor="delivery-email">Email</BestLabel>
                  <Input
                    type="email"
                    className="form-control"
                    id="delivery-email"
                    value={parkingPassStore.deliveryEmail}
                    onChange={deliveryEmail => parkingPassStore.setDeliveryEmail(deliveryEmail.target.value)}
                  />
                </div>
                <div className="col-lg-4 col-12 form-group">
                  <BestLabel htmlFor="intl-tel-input-1">Mobile Phone</BestLabel>
                  <PhoneInputWithCountrySelect
                    placeholder="US/Canada Only"
                    defaultCountry={parkingPassStore.countryCode || "US"}
                    countries={["US", "CA"]}
                    international={false}
                    addInternationalOption={false}
                    countryCallingCodeEditable={false}
                    className={
                      "d-flex form-control " +
                      (!parkingPassStore.deliveryMobilePhone || isValidPhoneNumber(parkingPassStore.deliveryMobilePhone)
                        ? ""
                        : "is-invalid")
                    }
                    onChange={value => {
                      parkingPassStore.setDeliveryMobilePhone(value);
                    }}
                    onCountryChange={value => {
                      parkingPassStore.setCountryCode(value);
                    }}
                    value={parkingPassStore.deliveryMobilePhone}
                  />
                </div>
              </React.Fragment>
            ) : null}
          </div>
          <div className="row justify-content-end">
            <div className="text-right mr-4">
              <ButtonLink
                style={{ fontSize: "0.875rem", padding: "0px" }}
                onClick={() => contactStore.setShowNewContactModal(true)}
              >
                Save Contact
              </ButtonLink>
            </div>
          </div>
          <div className="row">
            <div className="col-12 form-group">
              <BestLabel htmlFor="comments">Comments</BestLabel>
              <CommentInput
                className="form-control"
                name="comments"
                id="comments"
                value={parkingPassStore.comments}
                onChange={comment => parkingPassStore.setComments(comment.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default inject("rootStore")(observer(ParkingPassFilters));
